module.exports = __webpack_public_path__ + "static/media/plusCircle.89976ba3.svg";